<template>
  <div class="active_table">
    <toolbar>
      <div class="search">
        <!-- rtu选择 -->
        <div class="label">分组名称：</div>
        <Select v-model="search.rtuCode" style="width: 7.8em" placeholder="请选择分组" clearable>
          <Option v-for="item in rtuList" :value="item.code" :key="item.id">{{ item.name }}</Option>
        </Select>
        <DatePicker type="daterange" placement="bottom-end" placeholder="选择日期" style="width: 200px;margin-left: 10px"
          @on-change="dateSelect($event)"></DatePicker>
        <Select v-model="search.timeSegmentation" clearable style="width:100px;margin-left:10px;text-align:center;">
          <Option v-for="item in timeSegmentationList" :key="item.value" :value="item.value">{{ item.name }}</Option>
        </Select>
        <i-button type="default" @click="searchFunc" style="margin-left: 1em;">搜索</i-button>
      </div>
    </toolbar>
    <div class="table">
      <div v-for="item in filterChartsList" :key="item.id" class="chart_item_index" :style="active.chartsBox">
        <div class="table_item">
          <v-chart autoresize :options="item.options" />
          <i-button style="position: absolute; right: 10px;top: 20px" @click="openBig(item.id)">{{ active.title
          }}</i-button>
          <Spin fix v-show="item.loading"></Spin>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.active_table {
  width: 100%;
  height: 100%;
}

.table {
  padding: 0 1em;
  width: 100%;
  height: calc(100% - 7.5em);
  position: relative;
  display: flex;
  flex-wrap: wrap;

  .chart_item_index {
    width: 25%;
    height: 50%;
  }

  .table_item {
    width: 100%;
    height: 100%;
    position: relative;
  }

  .echarts {
    width: 100%;
    height: 100%;
  }
}

.content {
  width: 700px;

  img {
    width: 100%;
  }
}
</style>

<script>
import toolbar from "../toolBar.vue";
import { timeStamp } from "../../../util/common/date";
import { fontSize } from "@/util/common/fontSize"; // 字体适配

export default {
  data() {
    return {
      // 查询
      search: {
        rtuCode: null,
        startDate: new Date().setHours("0"),
        endDate: new Date().getTime(),
        timeSegmentation: 3600
      },
      chartsBoxShow: [],
      // 图表
      chartsList: [
        {
          options: {},
          loading: true,
          id: 0
        },
        {
          options: {},
          loading: true,
          id: 1
        },
        {
          options: {},
          loading: true,
          id: 2
        },
        {
          options: {},
          loading: true,
          id: 3
        },
        {
          options: {},
          loading: true,
          id: 4
        },
        {
          options: {},
          loading: true,
          id: 5
        },
        {
          options: {},
          loading: true,
          id: 6
        },
        {
          options: {},
          loading: true,
          id: 7
        }
      ],

      rtuList: [], // rtu枚举列表
      rtuDeviceList: {}, // rtu对应接口对象
      timeSegmentationList: [
        {
          name: "每分钟",
          value: 60
        },
        {
          name: "每十分钟",
          value: 600
        },
        {
          name: "每小时",
          value: 3600
        }
      ],

      active: {
        title: "放大",
        showChart: [0, 1, 2, 3, 4, 5, 6, 7],
        chartsBox: {
          width: "25%",
          height: "50%"
        }
      }
    };
  },
  computed: {
    filterChartsList() {
      return this.chartsList.filter((item, itemIndex) => {return this.chartsBoxShow[itemIndex] != -1 && this.active.showChart.indexOf(item.id) >=0 ;});
    }
  },
  components: {
    toolbar
  },
  created() {
    this.getRtuEnum(); // 获取rtu端口对应设备 渲染表头 数据初始化
  },
  methods: {
    getData() {
      let self = this;
      // 获取数据
      this.$api.Report.getReportList(
        {
          content: this.search,
          paging: false
        },
        ["uuid", "company"]
      ).then(res => {
        if (res.code == 0) {
          // 获取成功 res.data.list
          let ajaxData = res.data; // 请求过来的数据
          let xAxisData = []; // x轴的时间
          let seriesMap = {
            ai0: [],
            ai1: [],
            ai2: [],
            ai3: [],
            ai4: [],
            ai5: [],
            ai6: [],
            ai7: []
          };
          for (let i = 0, length = ajaxData.length; i < length; i++) {
            xAxisData.push(timeStamp(ajaxData[i].createDate, "MM-dd HH:mm"));
            seriesMap.ai0.push(ajaxData[i].ai0 || 0);
            seriesMap.ai1.push(ajaxData[i].ai1 || 0);
            seriesMap.ai2.push(ajaxData[i].ai2 || 0);
            seriesMap.ai3.push(ajaxData[i].ai3 || 0);
            seriesMap.ai4.push(ajaxData[i].ai4 || 0);
            seriesMap.ai5.push(ajaxData[i].ai5 || 0);
            seriesMap.ai6.push(ajaxData[i].ai6 || 0);
            seriesMap.ai7.push(ajaxData[i].ai7 || 0);
          }
          //console.log(seriesMap);
          for (let i = 0; i < 8; i++) {
            // 先写死8个端口
            this.chartsList[i].loading = false;
            this.chartsList[i].options = {
              title: {
                text: self.rtuDeviceList["aI" + i + "DeviceName"] || "数据位:" + i,
                textStyle: {
                  color: "#000",
                  fontSize: fontSize(16)
                },
                left: "center"
              },
              xAxis: {
                type: "category",
                axisLabel: {
                  color: "#000",
                  fontSize: fontSize(12, "font"),
                  align: "center"
                },
                axisLine: {
                  lineStyle: {
                    color: "#000",
                    width: fontSize(1, "border"),
                    opacity: 0.6
                  }
                },
                axisTick: {
                  show: false
                },
                data: xAxisData
              },
              yAxis: {
                axisLabel: {
                  // y轴数据的样式
                  color: "#000",
                  fontSize: fontSize(12, "font")
                },
                axisLine: {
                  // 线条样式
                  lineStyle: {
                    color: "#000",
                    width: fontSize(1, "border"),
                    opacity: 0.6,
                    symbol: "arrow"
                  }
                },
                axisTick: {
                  // 刻度 鼠标选中的刻度样式
                  show: false
                },
                splitLine: {
                  // 网格
                  show: false
                }
              },
              tooltip: {
                trigger: "axis",
                textStyle: {
                  fontSize: fontSize(14)
                },
                axisPointer: {
                  lineStyle: {
                    width: fontSize(2, "width"),
                    color: {
                      type: "linear",
                      x: 0,
                      y: 0,
                      x2: 0,
                      y2: 1,
                      colorStops: [
                        {
                          offset: 0,
                          color: "rgba(0, 254, 255, 0.1)" // 0% 处的颜色
                        },
                        {
                          offset: 0.5,
                          color: "rgba(0, 254, 255, 1)" // 100% 处的颜色
                        },
                        {
                          offset: 1,
                          color: "rgba(0, 254, 255, 0.1)" // 100% 处的颜色
                        }
                      ],
                      global: false // 缺省为 false
                    }
                  }
                }
              },
              series: {
                type: "line",
                itemStyle: {
                  color: "#143d25"
                },
                lineStyle: {
                  color: "#143d25",
                  width: fontSize(2, "width"),
                  opacity: 0.6
                },
                areaStyle: {
                  color: {
                    type: "linear",
                    x: 0,
                    y: 0,
                    x2: 0,
                    y2: 1,
                    colorStops: [
                      {
                        offset: 0,
                        color: "rgba(33, 102, 61, 0.47)" // 0% 处的颜色
                      },
                      {
                        offset: 1,
                        color: "rgba(18, 119, 47, 0)" // 100% 处的颜色
                      }
                    ],
                    global: false // 缺省为 false
                  }
                },
                smooth: false,
                data: seriesMap["ai" + i]
              }
            };
          }

          this.$Message.success("加载完成");
        } else {
          this.$Message.warning(res.message);
          this.table.loading = false;
        }
      });
    },
    // 搜索
    searchFunc() {
      this.getRtuDevice();
    },
    pageCurrentChange(num) {
      // 页码跳转
      this.table.pageCurrent = num;
      this.getData();
    },
    pageSizeChange(num) {
      // 每页数量切换
      this.table.pageSize = num;
      this.getData();
    },
    // 获取rtu枚举值
    getRtuEnum() {
      this.$api.Enum.getRtuEnum(null, ["uuid", "company"]).then(res => {
        if (res.code == 0) {
          this.rtuList = res.data;
          if (this.rtuList.length == 0) {
            // 当没有rtu的情况下
            this.getData();
            return;
          }
          // 获取枚举数据后 默认选择第一个枚举查rtu端口对应设备
          if (this.rtuList.length != 0) {
            this.search.rtuCode = this.rtuList[0].code;
            this.getRtuDevice();
          }
        } else {
          this.$Notice.warning({
            title: "获取分组枚举失败",
            desc: res.message || "请联系管理员"
          });
        }
      });
    },
    // 获取rtu 8个端口对应的设备
    getRtuDevice() {
      this.$api.Deploy.getRtuList({ content: { code: this.search.rtuCode } }, [
        "uuid",
        "company"
      ]).then(res => {
        if (res.code == 0 && res.data.list.length != 0) {
          let data = res.data.list[0];
          this.chartsBoxShow = [];
          for (let i = 0; i < 8; i++) {
            this.chartsBoxShow.push(data["aI" + i]);
          }
          //console.log(this.chartsBoxShow);
          this.rtuDeviceList = data; // {ai...}
          this.getData(); // 渲染好表头后加载数据
        } else {
          this.$Notice.warning({
            title: "获取端口对应设备失败",
            desc: res.message || "请联系管理员"
          });
        }
      });
    },
    // 选择时间
    dateSelect(date) {
      this.search.startDate = new Date(date[0]).setHours("0");
      this.search.endDate = new Date(date[1]).setHours("24");
      //console.log(this.search);
    },
    // 放大echarts表
    openBig(id) {
      if (this.active.title == "放大") {
        this.active.chartsBox = {
          width: "100%",
          height: "100%"
        };
        this.active.showChart = [id];

        this.active.title = "缩小";
      } else {
        this.active.chartsBox = {
          width: "25%",
          height: "50%"
        };
        this.active.showChart = [0, 1, 2, 3, 4, 5, 6, 7];
        this.active.title = "放大";
      }
    }
  }
};
</script>